import { render, staticRenderFns } from "./ModalDeleteDeveloper.vue?vue&type=template&id=065da2ae&"
import script from "./ModalDeleteDeveloper.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteDeveloper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports